import { styled, Typography } from '@mui/material';
import React from 'react';
import { Colors } from '../themes';
import { t } from 'i18next';

const CornerRibbon = styled('div')({
  position: 'absolute',
  top: '25px',
  right: '-40px',
  padding: '10px 2em',
  width: '175px',
  transform: 'rotate(45deg)',
  pointerEvents: 'none',
  zIndex: 9,
  boxShadow: '0 0 10px rgba(0,0,0,.3)',
  backgroundColor: Colors.alternateBase,
});

interface MobileCornerRibbonProps {
  msg?: string;
  position?: 'top-left' | 'top-right' | 'bottom-left' | 'bottom-right';
  className?: string;
}

const MobileCornerRibbon: React.FC<MobileCornerRibbonProps> = (props) => {
  /* TODO the designs want a ribbon that wraps more around the card; come back to make this better if time allows */
  const { msg = 'Premium', position = 'top-right', className } = props;

  return (
    <CornerRibbon className={`corner-ribbon ${position} ${className}`}>
      <Typography
        width='100%'
        variant='p16Bold'
        color='secondary'
        sx={{
          justifyContent: 'center',
        }}>
        {t(msg)}
      </Typography>
    </CornerRibbon>
  );
};

export default MobileCornerRibbon;
